export default __webpack_public_path__ + "static/media/brita.b0866d18.svg";